import { render, staticRenderFns } from "./InviteDialog.vue?vue&type=template&id=5f1b9fec"
import script from "./InviteDialog.vue?vue&type=script&lang=js"
export * from "./InviteDialog.vue?vue&type=script&lang=js"
import style0 from "./InviteDialog.vue?vue&type=style&index=0&id=5f1b9fec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports